export default "__VITE_ASSET__df208578__"